import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Quote } from "lucide-react";

/**
 * "Ce spun profesorii" (30.10.2026): the testimonials participants gave with
 * the final feedback and the team published — from 3 up, otherwise the
 * section stays away (decision T4). The four sample texts it showed before
 * were never real.
 */

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/testimonials").then((r) => { if (alive) setItems(r.data.items || []); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (items.length < 3) return null;
  return (
    <section id="testimonials" className="scroll-mt-28 py-20 md:py-28 relative overflow-hidden">
      <div
        className="absolute inset-0 -z-10 opacity-[0.06] bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1758270704524-596810e891b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxzY2hvb2wlMjBkaXZlcnNlJTIwc3R1ZGVudHMlMjBzbWlsaW5nfGVufDB8fHx8MTc3ODE0MTQ3Nnww&ixlib=rb-4.1.0&q=85)",
        }}
      />
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center rounded-full bg-white border border-[#E5E7EB] px-3 py-1 text-xs font-semibold text-[#373A45] uppercase tracking-widest">
            Ce spun profesorii
          </span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-[#373A45]">
            Părerile profesorilor care au urmat cursul.
          </h2>
        </div>
        <div className={`mt-12 grid grid-cols-1 md:grid-cols-2 ${items.length % 4 === 0 ? "lg:grid-cols-4" : "lg:grid-cols-3"} gap-5`}>
          {items.map((t, i) => (
            <div key={t.id} className="bg-white rounded-2xl p-6 border border-[#E5E7EB] flex flex-col" data-testid={`testimonial-card-${i}`}>
              <Quote className="text-[#965EA7]" size={22} />
              <p className="mt-4 text-[#373A45] leading-relaxed flex-1">{t.text}</p>
              <div className="mt-5 font-display font-semibold text-[#373A45]">{t.name}</div>
              <div className="text-xs text-[#6B7280]">{[t.role, t.city].filter(Boolean).join(", ")}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
